import {
  PlaidLinkError,
  PlaidLinkOnEventMetadata,
  PlaidLinkOnExitMetadata,
  PlaidLinkOnSuccessMetadata
} from 'react-plaid-link'
import AnalyticsHelper from './AnalyticsHelper'
import CloudEvent from './CloudEvent'
import APIService from 'api/APIService'

const TRACK_EVENTS = {
  PLAID_LINK_SUCCESS: 'PLAID_LINK_SUCCESS',
  PLAID_LINK_EVENT: 'PLAID_LINK_EVENT',
  PLAID_LINK_EXIT: 'PLAID_LINK_EXIT'
}

const TRACK_PARAMS = {
  META_DATA: 'META_DATA',
  LINK_TOKEN: 'LINK_TOKEN',
  SESSION_ID: 'SESSION_ID',
  ERROR_CODE: 'ERROR_CODE',
  ERROR_MESSAGE: 'ERROR_MESSAGE'
}

export const trackEvent = (
  eventName: string,
  metadata: PlaidLinkOnEventMetadata,
  linkToken: string
) => {
  if (eventName === 'EXIT') return
  AnalyticsHelper.trackEvent(TRACK_EVENTS.PLAID_LINK_EVENT, {
    [TRACK_PARAMS.META_DATA]: metadata,
    [TRACK_PARAMS.LINK_TOKEN]: linkToken,
    [TRACK_PARAMS.SESSION_ID]: metadata.link_session_id
  })
}

export const trackSuccess = (
  metadata: PlaidLinkOnSuccessMetadata,
  linkToken: string
) => {
  AnalyticsHelper.trackEvent(TRACK_EVENTS.PLAID_LINK_SUCCESS, {
    [TRACK_PARAMS.META_DATA]: metadata,
    [TRACK_PARAMS.LINK_TOKEN]: linkToken,
    [TRACK_PARAMS.SESSION_ID]: metadata.link_session_id
  })
}

export const trackExit = (
  error: PlaidLinkError | null,
  metadata: PlaidLinkOnExitMetadata,
  linkToken: string
) => {
  const properties = {
    [TRACK_PARAMS.META_DATA]: metadata,
    [TRACK_PARAMS.LINK_TOKEN]: linkToken,
    [TRACK_PARAMS.ERROR_CODE]: error?.error_code,
    [TRACK_PARAMS.ERROR_MESSAGE]: error?.error_message
  }
  AnalyticsHelper.trackEvent(TRACK_EVENTS.PLAID_LINK_EXIT, properties)
}

export const PlaidHandlers = {
  AddCard: {
    onSuccess: ({
      metadata,
      link_token
    }: {
      metadata: PlaidLinkOnSuccessMetadata
      link_token: string
    }) => {
      AnalyticsHelper.trackEvent(CloudEvent.LoginToInstitutionUserComplete)
      trackSuccess(metadata, link_token)
    },
    onEvent: ({
      eventName,
      metadata,
      link_token
    }: {
      eventName: string
      metadata: PlaidLinkOnEventMetadata
      link_token: string
      bankNames: string[]
      isPremium: boolean
    }) => {
      trackEvent(eventName, metadata, link_token)
    },
    onExit: ({
      error,
      metadata,
      link_token
    }: {
      error: PlaidLinkError | null
      metadata: PlaidLinkOnExitMetadata
      link_token: string
    }) => {
      trackExit(error, metadata, link_token)
    }
  },
  UpdateLogin: {
    onSuccess: ({
      metadata,
      link_token
    }: {
      metadata: PlaidLinkOnSuccessMetadata
      link_token: string
    }) => {
      trackSuccess(metadata, link_token)
      AnalyticsHelper.trackEvent(CloudEvent.SelectedUpdateLoginInstitution)
    },
    onEvent: ({
      eventName,
      metadata,
      link_token
    }: {
      eventName: string
      metadata: PlaidLinkOnEventMetadata
      link_token: string
    }) => {
      trackEvent(eventName, metadata, link_token)
    },
    onExit: ({
      error,
      metadata,
      link_token
    }: {
      error: PlaidLinkError | null
      metadata: PlaidLinkOnExitMetadata
      link_token: string
    }) => {
      trackExit(error, metadata, link_token)
    }
  },
  UpdatePlaid: {
    onSuccess: ({
      token_id,
      metadata,
      link_token
    }: {
      token_id: string
      metadata: PlaidLinkOnSuccessMetadata
      link_token: string
    }) => {
      trackSuccess(metadata, link_token)
      APIService.misc.reconnectInstitution({ token_id })
    },
    onEvent: ({
      eventName,
      metadata,
      link_token
    }: {
      eventName: string
      metadata: PlaidLinkOnEventMetadata
      link_token: string
    }) => {
      trackEvent(eventName, metadata, link_token)
    },
    onExit: ({
      error,
      metadata,
      link_token
    }: {
      error: PlaidLinkError | null
      metadata: PlaidLinkOnExitMetadata
      link_token: string
    }) => {
      trackExit(error, metadata, link_token)
    }
  },
  StripeForm: {
    onSuccess: ({
      metadata,
      link_token
    }: {
      metadata: PlaidLinkOnSuccessMetadata
      link_token: string
    }) => {
      trackSuccess(metadata, link_token)
    },
    onEvent: ({
      eventName,
      metadata,
      link_token
    }: {
      eventName: string
      metadata: PlaidLinkOnEventMetadata
      link_token: string
    }) => {
      trackEvent(eventName, metadata, link_token)
    },
    onExit: ({
      error,
      metadata,
      link_token
    }: {
      error: PlaidLinkError | null
      metadata: PlaidLinkOnExitMetadata
      link_token: string
    }) => {
      trackExit(error, metadata, link_token)
    }
  }
}
